/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDTO } from './userDTO';


export interface TransactionDTO {
    amount: number;
    currency: string;
    description?: string;
    expirationDate: string;
    gatewayCode: string;
    id?: string;
    issueDate: string;
    user?: UserDTO;
}

